export * from './capitalize.pipe';
export * from './category-events.pipe';
export * from './category-image.pipe';
export * from './category-items.pipe';
export * from './category-label.pipe';
export * from './device-location.pipe';
export * from './device-events.pipe';
export * from './device-name.pipe';
export * from './distinct-proxies.pipe';
export * from './event-display.pipe';
export * from './friendly-proxyname.pipe';
export * from './has-proxy.pipe';
export * from './list-filter.pipe';
export * from './location-events.pipe';
export * from './location-items.pipe';
export * from './name-filter.pipe';
export * from './normalize-category.pipe';
export * from './room-items.pipe';
export * from './room-events.pipe';
export * from './singularize.pipe';
export * from './readable.pipe';

export * from './fontawesome-class.pipe';
export * from './select-locations.pipe';
export * from './select-rooms.pipe';
export * from './select-devices.pipe';

export * from './item-display.pipe';
export * from './has-params.pipe';

export * from './labelize.pipe';
export * from './value-display.pipe';

export * from './matching-display.pipe';
export * from './items-by-name-or-room.pipe';
export * from './device-icon.pipe';
export * from './aggregate-display.pipe';
export * from './composed-title.pipe';

export * from './schedule-events.pipe';
export * from './happening-today.pipe';
export * from './expired-recurrence.pipe';



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/index.ts